var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:{
    'flex justify-start': true,
    'pb-3': _vm.description,
    'pb-4': !_vm.description,
  }},[_c('div',{class:{
      'flex flex-shrink-0 items-center justify-center box-content': true,
      'w-18': !_vm.portrait,
      'w-12 h-12 px-6 pt-5.5': _vm.portrait,
    }},[(_vm.portrait)?_c('ProcessedImage',{attrs:{"src":_vm.portrait,"width":_vm.portraitSize,"height":_vm.portraitSize,"transforms":{ preset: 'icon', width: _vm.portraitSize, height: _vm.portraitSize },"alt":_vm.__('Icon')}}):_vm._e()],1),_vm._v(" "),_c('div',{class:{
      'max-w-[85%]': true,
      'mt-5.5': !_vm.description,
      'mt-3': _vm.description,
    }},[_c('SurfaceBuilder',{class:'text-12-14'}),_vm._v(" "),_c('h1',{class:{
        'mt-0.5': true,
        'min-h-[38px]': !_vm.description,
        [_vm.fontClass]: true,
        'text-surface-title font-semibold break-words': true,
        'text-dark-text-100': _vm.isMap ? _vm.colorScheme === 'light' : _vm.backgroundLuminance === 'light',
        'text-light-text-100': _vm.isMap ? _vm.colorScheme === 'dark' : _vm.backgroundLuminance === 'dark',
      },on:{"dblclick":function($event){!_vm.isEmbedded && _vm.tryModify()}}},[_vm._v("\n      "+_vm._s(_vm.title || _vm.__('Untitled padlet'))+"\n    ")]),_vm._v(" "),(_vm.description)?_c('SurfaceTitleDescription',{class:['mt-0.5'],attrs:{"text":_vm.description,"font-id":_vm.fontId,"color-scheme":_vm.isMap ? _vm.colorScheme : _vm.backgroundLuminance},nativeOn:{"dblclick":function($event){!_vm.isEmbedded && _vm.tryModify()}}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }